import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import { PGA_COM_HOST } from 'env'

const WAITLIST_SOURCE_MESSAGE =
  'The spot has been filled. We will notify you again if a new slot opens.'
const WAITLIST_AVAILABLE_MESSAGE =
  'Registration is full. Join our waitlist to be notified if space becomes available or when the next session opens.'
const REGISTRATION_FULL_MESSAGE = 'Registration is full'

const RegistrationFullDialog = ({
  isOpen,
  onClose,
  groupEvent,
  fromWaitlist,
}) => {
  let message = REGISTRATION_FULL_MESSAGE
  let action = {
    label: 'Find Events Near You',
    href: `${PGA_COM_HOST}/golf-lessons`,
  }
  if (fromWaitlist) {
    message = WAITLIST_SOURCE_MESSAGE
  } else if (groupEvent.hasWaitlist) {
    message = WAITLIST_AVAILABLE_MESSAGE
    action = {
      label: 'View Event',
      href: `${PGA_COM_HOST}/things-to-do/events/${groupEvent.slug}`,
    }
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      showCloseButton
      aria-labelledby="registration-full-dialog-title"
    >
      {() => (
        <Box m={2}>
          <DialogTitle id="registration-full-dialog-title">
            Registration Full
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" color="textSecondary">
              {message}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" href={action.href}>
              {action.label}
            </Button>
          </DialogActions>
        </Box>
      )}
    </Dialog>
  )
}

RegistrationFullDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  groupEvent: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    hasWaitlist: PropTypes.bool,
  }).isRequired,
  fromWaitlist: PropTypes.bool,
}

export default RegistrationFullDialog
